import { render, staticRenderFns } from "./ProxySetting.vue?vue&type=template&id=121dbf45"
import script from "./ProxySetting.vue?vue&type=script&lang=js"
export * from "./ProxySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports